import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCustomFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    fill="none"
    {...props}
  >
    <circle cx={22.5} cy={22.5} r={22.5} fill="url(#customFolderGradient)" />
    <path
      fill="#fff"
      d="M14.5 16a1.5 1.5 0 0 0-1.5 1.5v10a1.5 1.5 0 0 0 1.5 1.5h16a1.5 1.5 0 0 0
      1.5-1.5v-8a1.5 1.5 0 0 0-1.5-1.5h-7.172a1.5 1.5 0 0 1-1.06-.44l-1.06-1.06a1.5
      1.5 0 0 0-1.061-.44H14.5Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.3}
      d="M14.5 16a1.5 1.5 0 0 0-1.5 1.5v2h19v-.5a1.5 1.5 0 0 0-1.5-1.5h-7.172a1.5
      1.5 0 0 1-1.06-.44l-1.06-1.06a1.5 1.5 0 0 0-1.061-.44H14.5Z"
    />
    <defs>
      <linearGradient
        id="customFolderGradient"
        x1={0}
        x2={45}
        y1={0}
        y2={45}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9333EA" />
        <stop offset={1} stopColor="#C084FC" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgCustomFolder;
